module.exports = __webpack_public_path__ + "static/media/under-construction.a5c49392.svg";